import {
  CREATE_RATING,
  CREATE_RATING_FAILED,
  CREATE_RATING_REPLY,
  CREATE_RATING_REPLY_FAILED,
  CREATE_RATING_REPLY_SUCCESS,
  CREATE_RATING_SUCCESS,
  GET_RATINGS_BY_VENUE_OWNER_ID,
  GET_RATINGS_BY_VENUE_OWNER_ID_FAILED,
  GET_RATINGS_BY_VENUE_OWNER_ID_SUCCESS,
} from './constants';

const updateRatingsWithReply = (ratings, reply) =>
  ratings.map((rating) =>
    rating.id === reply.rating.id ? { ...rating, replies: [...rating.replies, reply] } : rating,
  );

const initialState = {
  rating: {},
  ratings: [],
  loading: false,
  error: null,
};

const ratingReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case CREATE_RATING:
    case GET_RATINGS_BY_VENUE_OWNER_ID:
    case CREATE_RATING_REPLY:
      return { ...state, loading: true };
    case GET_RATINGS_BY_VENUE_OWNER_ID_SUCCESS:
      return { ...state, ratings: action.payload.ratings, loading: false };
    case CREATE_RATING_SUCCESS:
      return { ...state, rating: action.payload.rating, loading: false };
    case CREATE_RATING_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        ratings: updateRatingsWithReply(state.ratings, action.payload.reply),
      };
    case GET_RATINGS_BY_VENUE_OWNER_ID_FAILED:
    case CREATE_RATING_FAILED:
    case CREATE_RATING_REPLY_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    default:
      return state;
  }
};

export default ratingReducer;
